import React, { useEffect, useState } from 'react'
import { Button } from '@olxbr/ds-core'
import styled from 'styled-components'
import { declineAccessToUser, grantAccessToUser, getClientNameById } from '../../../api/oauthApi'

const ContentWrapper = styled.div`
  padding-left: 25px;
`
const MainContent = styled.div``
const List = styled.ul`
  margin-left: 30px;
`
const ListItems = styled.li`
  padding: 10px;
`
const ButtonsWrapper = styled.div`
  margin-right: 100px;
`
const getScopeDescriptions = scopeFromQueryString => {
  const basicUserInfo = scopeFromQueryString?.includes('basic_user_info')
  const autoUpload = scopeFromQueryString?.includes('autoupload')
  const descriptions = []

  if (basicUserInfo) {
    descriptions.push('Obter informações da sua conta de usuário')
  }

  if (autoUpload) {
    descriptions.push('Poder inserir anúncios na sua conta de usuário')
  }

  return descriptions
}

const OauthPage = props => {
  const accessData = {
    scope: props.scope,
    state: props.state,
    redirect_uri: props.redirectUri,
    response_type: props.responseType,
    client_id: props.clientId,
  }

  const redirectToErrorPage = errorMenssage => {
    window.location.href = `/error?errorMessage=${encodeURIComponent(errorMenssage)}`
    return
  }

  const validateAccessData = accessData => {
    const keys = Object.keys(accessData)
    const emptyValue = keys.find(key => !accessData[key] && key != 'response_type')
    if (emptyValue) {
      redirectToErrorPage('Erro ao obter as Query Strings')
    }
  }

  const [clientName, setClientName] = useState('')
  const descriptions = getScopeDescriptions(props.scope)

  useEffect(() => {
    validateAccessData(accessData)
    const fetchData = async () => {
      const name = await getClientNameById(props.clientId, accessData)
      if (!name) {
        redirectToErrorPage('Erro ao obter o nome do cliente')
      }
      setClientName(name.replace(/\b\w/g, firstchar => firstchar.toUpperCase()))
    }
    if (!!props.clientId) {
      fetchData()
    }
    fetchData()
  }, [props.clientId])

  return (
    <ContentWrapper>
      <MainContent>
        <span className="typo-title-medium mt-5 mb-2">{clientName}</span>
        <span className="typo-body-medium font-bold mb-1-5">{clientName} gostaria de:</span>
      </MainContent>
      <List>
        {descriptions.map((description, index) => (
          <ListItems key={index}>
            <span className="typo-body-medium">{description}</span>
          </ListItems>
        ))}
      </List>
      <span className="typo-body-medium mb-10">
        {clientName} e a OLX utilizarão essas informações em conformidade com seus respectivos
        Termos de Serviços e Políticas de privacidade.
      </span>
      <ButtonsWrapper>
        <div className="flex flex-row items-end justify-end">
          <Button
            variant="tertiary"
            className="mb-6"
            onClick={async () => {
              declineAccessToUser(accessData)?.then(response => {
                window.location.replace(response.data.redirect)
              })
            }}
          >
            Cancelar
          </Button>
          <Button
            className="ml-1 mb-6"
            onClick={async () => {
              grantAccessToUser(accessData)?.then(response => {
                window.location.replace(response.data.redirect)
              })
            }}
          >
            Aceitar
          </Button>
        </div>
      </ButtonsWrapper>
    </ContentWrapper>
  )
}

export { OauthPage }
